import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';

export type DeleteFileParams = {
  channelId: number;
  messageId: number;
  attachmentId: number;
};

const deleteFile = async (params: DeleteFileParams) => {
  const { channelId, messageId, attachmentId } = params;
  return axios.delete(
    `${MESSAGING_API_BASE}/channels/${channelId}/messages/${messageId}/attachments/${attachmentId}`
  );
};

export const useDeleteFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteFile,
    onSuccess: (_, variables) => {
      // Invalidate files query to refetch the list
      queryClient.invalidateQueries({
        queryKey: messagingQueryKeys.files(variables.channelId),
      });
    },
  });
};
